import { getPermissionsAdapter } from '@shell/adapters/permissions'
import exclude from './exclude-config'

/**
 * Validate a component-level permission ID outside the React cycle (e.g. route guards).
 * Delegates to PermissionsAdapter.evaluateComponentById which reads from the Redux store
 * and preserves the OR logic: static check first, then dynamicFn as a standalone fallback.
 */
const accessValidator = (configId: string): boolean => {
  return getPermissionsAdapter().evaluateComponentById(configId, exclude)
}

export default accessValidator
